import _ from 'lodash';

const stickyScrollHandler = function($headerSelector) {
  return _.debounce(function() {
    if (
      window.scrollY > document.getElementById($headerSelector).clientHeight
    ) {
      document.getElementById($headerSelector).classList.add('stuck');
    } else {
      document.getElementById($headerSelector).classList.remove('stuck');
    }
  }, 200);
};

const StickyHeader = function($headerSelector) {
  document.getElementById($headerSelector).classList.add('sticky');

  stickyScrollHandler($headerSelector);

  document.addEventListener('scroll', stickyScrollHandler($headerSelector));
};

export default StickyHeader;



// WEBPACK FOOTER //
// ./scripts/util/StickyHeader.js